import { isObject } from "@pineapplelab/util";
import { FBase } from "./FBase";
import { Paging, PagingOrderType } from "@pineapplelab/paging";

export class UserProfile extends FBase {
  avatar: string;
  description: string;
  images: string[];
  title: string;
  type: string;
  video: boolean;
  artistId: string;
  isActive: boolean;
  constructor(json?: { [key: string]: any }) {
    super();
    if (isObject(json)) {
      this.fromJson(json);
    }
  }
}

export namespace UserProfile {

  export const PATH = 'profiles';

  export const PAGING = new Paging<UserProfile>(<Paging.IPaging>{
    collection: PATH,
    orderBy: 'artist_id',
    orderOptions: [
      { field: 'artist_id', label: 'Artist Id', placeholder: 'Filter by Artist id', dataType: Paging.dataType.string },
      { field: 'created_at', label: 'Created At', placeholder: 'Filter by Created At', dataType: Paging.dataType.timestamp },
      { field: 'is_active', label: 'Is Active', placeholder: 'Filter by Is Active', dataType: Paging.dataType.string }
    ],
    orderType: PagingOrderType.desc,
  });

}
